exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".book-search-wrapper{margin-top:20px;margin-bottom:10px}.bk-wrapper{cursor:pointer;margin-bottom:10px;padding:10px;background:#f9f9f9;border-radius:3px}.bk-wrapper:hover{background:#fff}.bk-name{color:#0bbd9e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/selector.js?type=style&index=0!./src/views/book-view.vue
// module id = 64
// module chunks = 0